import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Search, Layers, FileWarning, ClipboardList, Settings2 } from 'lucide-react';

const ITEMS = [
  { href: '/app/wallet-intel', label: 'Dashboard', icon: LayoutDashboard, exact: true },
  { href: '/app/wallet-intel/lookup', label: 'Wallet Lookup', icon: Search },
  { href: '/app/wallet-intel/batch', label: 'Batch Screening', icon: Layers },
  { href: '/app/wallet-intel/reports', label: 'SAR / STR Export', icon: FileWarning },
  { href: '/app/wallet-intel/audit', label: 'Audit Trail', icon: ClipboardList },
  { href: '/app/wallet-intel/settings', label: 'Settings', icon: Settings2 },
];

export function WalletIntelSubNav() {
  const location = useLocation();

  return (
    <div className="flex items-center gap-1 mb-5 overflow-x-auto pb-1" style={{ borderBottom: '1px solid #182030' }}>
      {ITEMS.map((item) => {
        const active = item.exact
          ? location.pathname === item.href
          : location.pathname.startsWith(item.href);
        const Icon = item.icon;
        return (
          <Link
            key={item.href}
            to={item.href}
            className="flex items-center gap-2 px-3.5 py-2.5 rounded-t-lg whitespace-nowrap transition-colors flex-shrink-0"
            style={{
              color: active ? '#00C8FF' : '#8D96AC',
              background: active ? '#00C8FF10' : 'transparent',
              borderBottom: `2px solid ${active ? '#00C8FF' : 'transparent'}`,
              fontWeight: active ? 700 : 500,
              fontSize: 13,
            }}
          >
            <Icon size={14} />
            {item.label}
          </Link>
        );
      })}
    </div>
  );
}
